// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"2a0b640e","254":"deedd4f9","340":"951a8a72","471":"3e8755cb","622":"4f5dfd5b","828":"8041ad52","862":"843f418b","973":"d8a1b433"}[chunkId] + ".chunk.js";
};